import { Component, OnInit, OnDestroy } from '@angular/core';
import { ApiService } from './../../shared/services/api.service';
import { ActivatedRoute } from '@angular/router';
import { AppointmentCalendar } from './../../models/calendar/calendar.model';
import { Subscription } from 'rxjs';
import { DataUtils } from './../../shared/utils/data-utils';
import * as moment from 'moment';

@Component({
  selector: 'swb-appointments-window',
  templateUrl: './appointments-window.component.html'
})
export class AppointmentsWindowComponent implements OnInit, OnDestroy {

  private _subscription: Subscription;

  private _id: string;
  private _interval: string;
  public day: string;
  public dayObject: Date;
  public from: string;

  public showConfirmation: boolean;
  public toCancelId: number;
  public toReactivateId: number;

  public header = 'Appointment detail';

  public calendar: AppointmentCalendar;

  public isInitialized = false;

  public cancelled_reason = '';

  public get activeBookings(): Array<any> {
    return this.calendar ? this.calendar.appointment_calendar_bookings.filter((b: any) => !b.cancelled) : [];
  }

  constructor(
    private _apiService: ApiService,
    private _route: ActivatedRoute
  ) { }

  public ngOnInit(): void {
    if (typeof this._route.snapshot.params['id'] !== 'undefined') {
      this._id = this._route.snapshot.params['id'];
      this.day = this._route.snapshot.params['day'];
      this.from = this._route.snapshot.params['from'];
      this._interval = this._route.snapshot.params['interval'];
      this._getAppointments();
    }
  }

  public ngOnDestroy(): void {
    if (this._subscription) {
      this._subscription.unsubscribe();
    }
  }

  public getTitle(titleObject: any): string {
    return DataUtils.getTitle(titleObject);
  }

  public getDate(dateString: string): Date {
    return moment(dateString).toDate();
  }

  public prepareCancel(id: number): void {
    this.toCancelId = id;
    this.showConfirmation = true;
  }

  public prepareReactivate(id: number): void {
    this.toReactivateId = id;
    this.showConfirmation = true;
  }

  public resetConfirmation(): void {
    this.toCancelId = undefined;
    this.toReactivateId = undefined;
    this.cancelled_reason = '';
    this.showConfirmation = false;
  }

  public toggleBooking(): void {
    this.isInitialized = false;
    const id = this.toCancelId || this.toReactivateId;
    this._subscription = this._apiService.put({ cancelled_reason: this.cancelled_reason, cancelled: this.toCancelId ? true : false },
      `appointment_calendar_bookings/toggle_cancel/${id}`)
      .subscribe(
        (data: any) => {
          this.resetConfirmation();
          this._getAppointments();
        }
      );
  }

  public blockWindow(): void {
    this.isInitialized = false;
    this._subscription = this._apiService.post({
      appointment_calendar_id: this.calendar.id,
      minute_interval: this._interval,
      datetime_from: `${this.day} ${this.from}`
    }, 'appointment_calendar_bookings')
      .subscribe(
        (data: any) => {
          this.resetConfirmation();
          this._getAppointments();
        }
      );
  }

  public generateArray(obj: string): Array<any> {
    obj = JSON.parse(obj);
    return Object.keys(obj).map((key) => ({ key: key, value: obj[key] }));
  }

  private _getAppointments(): void {
    this._subscription = this._apiService.get(`appointment-calendars/${this._id}/${this.day}/${this.from}/${this._interval}`)
      .subscribe(
        (data: any) => {
          this.isInitialized = true;
          this.calendar = data.data;
        }
      );
  }
}
